function getReviewData() {
  const rating = localStorage.getItem('totalRating');
  const reviews = localStorage.getItem('totalReviews');

  const container = document.querySelector('.shop-rating');
  if (!container) return;

  const ratingEl = container.querySelector('.reviews-number');
  const reviewsEl = container.querySelector('.reviews-count');

  // Use cached data if available
  if (rating && reviews) {
    if (ratingEl) ratingEl.textContent = rating;
    if (reviewsEl) reviewsEl.textContent = reviews;
    return;
  }

  // Otherwise, fetch from DOM
  const ratingText = document.querySelector('.reputon-rating-stars .reputon-count-number')?.textContent?.trim();
  const reviewsText = document.querySelector('.reputon-reviews-count')?.textContent?.trim();

  if (!ratingText || !reviewsText) return;

  const reviewsNumber = parseInt(reviewsText.replace(/\D/g, ''), 10);

  // Save to localStorage
  localStorage.setItem('totalRating', ratingText);
  localStorage.setItem('totalReviews', reviewsNumber);

  // Update UI
  if (ratingEl) ratingEl.textContent = ratingText;
  if (reviewsEl) reviewsEl.textContent = reviewsNumber;
}

// Run after slight delay
setTimeout(getReviewData, 1000);

function hideGoogleReviewsWriteButtonOnDesktop() {
  if (!window.matchMedia("(min-width: 768px)").matches) return;

  const widgets = document.querySelectorAll('[class*="reputon-google-reviews-widget"]');
  widgets.forEach((widget) => {
    widget.querySelectorAll("a, button").forEach((el) => {
      const label = el.textContent?.trim().toLowerCase();
      if (!label) return;
      if (
        label.includes("dejar un comentario") ||
        label.includes("leave a review") ||
        el.className.toLowerCase().includes("write-review")
      ) {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("pointer-events", "none", "important");
      }
    });
  });
}

function watchGoogleReviewsWidget() {
  hideGoogleReviewsWriteButtonOnDesktop();

  const observer = new MutationObserver(hideGoogleReviewsWriteButtonOnDesktop);
  document.querySelectorAll(".google-reviews-section, .app-wrapper").forEach((root) => {
    observer.observe(root, { childList: true, subtree: true });
  });

  window.matchMedia("(min-width: 768px)").addEventListener("change", hideGoogleReviewsWriteButtonOnDesktop);
}

document.addEventListener("DOMContentLoaded", watchGoogleReviewsWidget);
setTimeout(hideGoogleReviewsWriteButtonOnDesktop, 1500);
setTimeout(hideGoogleReviewsWriteButtonOnDesktop, 3000);

document.addEventListener('DOMContentLoaded', function() {
  const variantLabels = document.querySelectorAll('.variations input[type=radio] + label[data-product-url]');
  if (!variantLabels) return;

  variantLabels.forEach(label => {
    label.addEventListener('click', function() {
      const url = this.dataset.productUrl;
      if (url) {
        window.location.href = url;
      }
    });
  });
  
  const drawer = document.querySelector('.side-panel.facet-drawer');
  const toggleBtn = document.querySelector('#Facets-Toggle');

  if (!drawer || !toggleBtn) return;

  document.addEventListener('click', function (e) {
    const clickedInsideDrawer = drawer.contains(e.target);
    const clickedToggleBtn = toggleBtn.contains(e.target);

    if (!clickedInsideDrawer && !clickedToggleBtn) {
      drawer.classList.remove('active');
    }
  });
  window.addEventListener('resize', () => {
    drawer.classList.remove('active');
  })
});


// ─── Stock Warning ────────────────────────────────────────────────────────
(function injectStockWarnStyles() {
  const s = document.createElement('style');
  s.textContent = [
    '.qty-stock-warning{',
    '  display:block;',
    '  color:#c0392b;',
    '  font-size:0.78rem;',
    '  font-weight:500;',
    '  margin-top:5px;',
    '  animation:qtyWarnIn .2s ease;',
    '  position:absolute;',
    '}',
    '@keyframes qtyWarnIn{',
    '  from{opacity:0;transform:translateY(-4px)}',
    '  to{opacity:1;transform:translateY(0)}',
    '}'
  ].join('');
  document.head.appendChild(s);
})();

function showQtyStockWarning(input, stock) {
  const qs = input.closest('quantity-selector');
  const anchor = qs || input.closest('.quantity') || input.parentElement;
  if (!anchor) return;

  // Remove any existing warning for this input
  const inputId = input.id || '';
  const prev = anchor.parentElement && anchor.parentElement.querySelector('.qty-stock-warning[data-input-id="' + inputId + '"]');
  if (prev) {
    clearTimeout(prev._autoRemove);
    prev.remove();
  }

  const warn = document.createElement('span');
  warn.className = 'qty-stock-warning';
  warn.setAttribute('data-input-id', inputId);
  warn.textContent = 'Only ' + stock + ' items available.';
  anchor.insertAdjacentElement('afterend', warn);

  const dismiss = function() { if (warn.isConnected) warn.remove(); };
  warn._autoRemove = setTimeout(dismiss, 3000);
  document.addEventListener('cart:refresh', dismiss, { once: true });
  document.addEventListener('line-item:change:end', dismiss, { once: true });
}
// ─────────────────────────────────────────────────────────────────────────────

function updateMinusButtons() {
  document.querySelectorAll('quantity-selector.cart-update input.qty').forEach(input => {
    const minusBtn = input.closest('quantity-selector').querySelector('.minus');
    if (minusBtn) {
      if (parseInt(input.value, 10) <= 1) {
        minusBtn.style.cursor = 'not-allowed';
        minusBtn.style.opacity = '0.5';
        minusBtn.disabled = true;
      } else {
        minusBtn.style.cursor = '';
        minusBtn.style.opacity = '';
        minusBtn.disabled = false;
      }
    }
  });
}
document.addEventListener('DOMContentLoaded', updateMinusButtons);
document.addEventListener('cart:refresh', updateMinusButtons);

const observer = new MutationObserver((mutations) => {
  let shouldUpdate = false;
  for (let i = 0; i < mutations.length; i++) {
    const m = mutations[i];
    if (m.type === 'childList') {
      for (let j = 0; j < m.addedNodes.length; j++) {
        const node = m.addedNodes[j];
        if (node.nodeType === 1) {
          if (node.tagName === 'QUANTITY-SELECTOR' || node.querySelector('quantity-selector')) {
            shouldUpdate = true;
            break;
          }
        }
      }
    }
    if (shouldUpdate) break;
  }
  if (shouldUpdate) updateMinusButtons();
});
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', function(e) {
  const minusBtn = e.target.closest('quantity-selector.cart-update .minus');
  if (minusBtn) {
    const qs = minusBtn.closest('quantity-selector');
    const input = qs.querySelector('input.qty');
    if (input && parseInt(input.value, 10) <= 1) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}, true);

document.addEventListener('change', function(e) {
  if (e.target && e.target.classList.contains('qty')) {
    const val = parseInt(e.target.value, 10);
    const max = parseInt(e.target.getAttribute('max'), 10);
    // Use isNaN check so min="0" is respected (don't default to 1 when attr=0)
    const minAttr = e.target.getAttribute('min');
    const min = minAttr !== null ? parseInt(minAttr, 10) : 1;
    
    if (!isNaN(max) && val > max) {
      // Reset to 1 (minimum) and show stock warning
      e.target.value = 1;
      showQtyStockWarning(e.target, max);
    } else if (isNaN(val) || val < min) {
      e.target.value = min;
    }
    
    const quantitySelector = e.target.closest('quantity-selector');
    if (quantitySelector && typeof quantitySelector.validateQtyRules === 'function') {
      quantitySelector.validateQtyRules();
    }
    updateMinusButtons();
  }
}, true);

function getVariantInventory(variantId) {
  if (!window._themeProducts) return null;
  for (const productId in window._themeProducts) {
    const product = window._themeProducts[productId];
    if (product && product.variants) {
      const variant = product.variants.find(v => v.id === parseInt(variantId, 10));
      if (variant) {
        return {
          inventory_quantity: variant.inventory_quantity,
          inventory_management: variant.inventory_management,
          inventory_policy: variant.inventory_policy
        };
      }
    }
  }
  return null;
}

document.addEventListener('change', function(e) {
  if (e.target && e.target.name === 'id') {
    const variantId = e.target.value;
    const info = getVariantInventory(variantId);
    if (info) {
      const container = e.target.closest('.product-form') || e.target.closest('form') || document;
      const qtyInput = container.querySelector('.qty');
      if (qtyInput) {
        if (info.inventory_management && (info.inventory_policy === 'deny' || info.inventory_quantity > 0)) {
          const maxVal = info.inventory_policy === 'deny' ? Math.max(0, info.inventory_quantity) : info.inventory_quantity;
          qtyInput.setAttribute('max', maxVal);
          if (parseInt(qtyInput.value, 10) > maxVal) {
            qtyInput.value = maxVal;
          }
        } else {
          qtyInput.removeAttribute('max');
        }
        
        const quantitySelector = qtyInput.closest('quantity-selector');
        if (quantitySelector && typeof quantitySelector.validateQtyRules === 'function') {
          quantitySelector.validateQtyRules();
        }
      }
    }
  }
}, true);

// When cart drawer opens: enforce qty limits from DOM, then deep sync
document.addEventListener('cart-drawer:open', function() {
  // Step 1 — Immediate: Liquid already rendered max=stock in HTML.
  // Enforce it right away so user never sees value > stock.
  // CartDrawer's native onChange handles the API update.
  setTimeout(enforceCartQtyByMax, 150);

  // Step 2 — Background: full API sync (catches edge cases, updates Shopify cart)
  syncCartStock();
  refreshKlarnaPlacements();
});

// Enforce max attribute on all cart qty inputs.
// The max attr is already set by Liquid from live inventory_quantity.
// When value > max, set value to max and dispatch change so CartDrawer handles the API call.
function enforceCartQtyByMax() {
  document.querySelectorAll('#Cart-Drawer input.qty').forEach(input => {
    const val = parseInt(input.value, 10);
    const max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && !isNaN(val) && val > max) {
      input.value = max;
      // CartDrawer listens to 'change' and calls updateQuantity(index, newValue)
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

// Refresh Klarna placements
function refreshKlarnaPlacements() {
  setTimeout(() => {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    console.log("update klarna");
    
  }, 2000);
}

// Also refresh Klarna when line items change
document.addEventListener('line-item:change:end', function() {
  refreshKlarnaPlacements();
});

// ─── Cart Stock Sync ────────────────────────────────────────────────────────
// Runs once when cart drawer opens. Fetches live variant inventory and:
//  - removes items with stock = 0
//  - reduces quantity to match available stock
// Uses a 15-second cooldown to prevent looping.
// Always refreshes the cart drawer UI at the end (even if no stock changes).
let _stockSyncAt = 0;

async function syncCartStock() {
  const now = Date.now();

  // Helper to refresh the cart drawer UI
  const doRefresh = () => {
    if (window._cartDrawerInstance && typeof window._cartDrawerInstance.refresh === 'function') {
      window._cartDrawerInstance.refresh();
    } else {
      // Fallback: use event system
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  };

  // On cooldown: still refresh UI with current cart data, but skip stock API calls
  if (now - _stockSyncAt < 15000) {
    doRefresh();
    return;
  }
  _stockSyncAt = now;

  try {
    const root = window.Shopify?.routes?.root || '/';

    // 1. Get current cart items
    const cartRes = await fetch(root + 'cart.js');
    if (!cartRes.ok) { doRefresh(); return; }
    const cart = await cartRes.json();
    if (!cart.items || cart.items.length === 0) { doRefresh(); return; }

    // 2. Fetch live inventory for all variants in parallel
    const stockMap = {};
    await Promise.all(cart.items.map(async (item) => {
      try {
        const res = await fetch(root + 'variants/' + item.variant_id + '.json');
        if (!res.ok) return;
        const data = await res.json();
        const v = data.variant;
        // Only enforce when Shopify tracks inventory with deny policy
        if (v && v.inventory_management === 'shopify' && v.inventory_policy === 'deny') {
          stockMap[item.variant_id] = v.inventory_quantity;
        }
      } catch (e) { /* skip if fetch fails */ }
    }));

    // 3. Build update payload
    const updates = {};
    let needsUpdate = false;
    for (const item of cart.items) {
      if (item.variant_id in stockMap) {
        const stock = stockMap[item.variant_id];
        if (stock <= 0) {
          updates[item.variant_id] = 0;  // remove
          needsUpdate = true;
        } else if (item.quantity > stock) {
          updates[item.variant_id] = stock;  // cap to stock
          needsUpdate = true;
        }
      }
    }

    if (!needsUpdate) { doRefresh(); return; }

    // 4. Apply via single bulk update
    const updateRes = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    if (!updateRes.ok) { doRefresh(); return; }

    // 5. Re-render cart drawer with updated data (no event dispatch = no loop risk)
    doRefresh();

  } catch (e) {
    console.error('[StockSync]', e);
    doRefresh();
  }
}
// ────────────────────────────────────────────────────────────────────────────

window.updatePromotionSideCards = function () {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  const items = Array.from(grid.children).filter(el => el.tagName === 'LI');

  items.forEach(item => {
    item.classList.remove(
      'promotion-side-top',
      'promotion-side-bottom',
      'promotion-side-last'
    );
  });

  const promotions = items.filter(item => item.classList.contains('promotion-column'));
  const productItems = items.filter(item => !item.classList.contains('promotion-column'));

  promotions.forEach(promo => {
    const promoRect = promo.getBoundingClientRect();
    const promoMidY = promoRect.top + promoRect.height / 2;

    const isHeight1 = promo.classList.contains('promotion-column-height--1');
    const isWidth2Height2 =
      promo.classList.contains('promotion-column-width--2') &&
      promo.classList.contains('promotion-column-height--2');

    const promoIndex = items.indexOf(promo);
    const itemsAfterPromo = items.slice(promoIndex + 1).filter(item => {
      return !item.classList.contains('promotion-column');
    });

    const isPromoAtEnd = isWidth2Height2 && itemsAfterPromo.length <= 2;

    items.forEach(item => {
      if (item === promo || item.classList.contains('promotion-column')) return;

      const rect = item.getBoundingClientRect();
      const itemMidY = rect.top + rect.height / 2;

      const samePromoArea = itemMidY > promoRect.top && itemMidY < promoRect.bottom;
      if (!samePromoArea) return;

      if (isPromoAtEnd && itemsAfterPromo.includes(item)) {
        item.classList.add('promotion-side-top', 'promotion-side-bottom', 'promotion-side-last');
        return;
      }

      if (itemMidY < promoMidY) {
        item.classList.add('promotion-side-top');

        if (isHeight1) {
          item.classList.add('promotion-side-bottom');
        }
      } else {
        item.classList.add('promotion-side-bottom');

        if (isHeight1) {
          item.classList.add('promotion-side-top');
        }
      }

      if (item === productItems[productItems.length - 1]) {
        item.classList.add('promotion-side-last');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', window.updatePromotionSideCards);
window.addEventListener('resize', window.updatePromotionSideCards);
document.addEventListener('shopify:section:load', window.updatePromotionSideCards);